<h2 mat-dialog-title>
  <mat-icon class="connect-shopify-icon">shopping_bag</mat-icon>
  <span i18n="@@Connect Shopify Store">Connect Shopify Store</span>
</h2>
<mat-dialog-content class="connect-shopify-content">
  <p class="connect-shopify-helper" i18n="@@connectShopifyHelper">
    Enter your Shopify shop handle to begin the install. We will redirect you to Shopify to approve the connection, then bring you back here.
  </p>

  <mat-form-field appearance="fill" class="connect-shopify-field">
    <mat-label i18n="@@Shop Handle">Shop Handle</mat-label>
    <input matInput
           type="text"
           name="shop"
           autocomplete="off"
           [(ngModel)]="shop"
           [disabled]="submitting"
           (keyup.enter)="onSubmit()"
           i18n-placeholder="@@shopHandlePlaceholder"
           placeholder="my-store or my-store.myshopify.com">
    <mat-hint i18n="@@shopHandleHint">Either the bare handle or the full .myshopify.com domain is accepted.</mat-hint>
  </mat-form-field>

  <div *ngIf="errorMessage" class="connect-shopify-error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button
          [disabled]="submitting"
          (click)="onCancel()"
          i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
  <button mat-raised-button
          color="primary"
          [disabled]="!canSubmit"
          (click)="onSubmit()">
    <mat-icon *ngIf="submitting" class="connect-shopify-spinner">hourglass_empty</mat-icon>
    <span *ngIf="!submitting" i18n="@@Continue to Shopify">Continue to Shopify</span>
    <span *ngIf="submitting" i18n="@@Connecting">Connecting…</span>
  </button>
</mat-dialog-actions>
